import { Field } from "typegraph";

import { ID } from "common/entities/IEntity";


export class Category {

	@Field()
	public id: ID;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/Category.ts